<script setup>
  import { storeToRefs } from "pinia";
  import TwoPanePage from "@templates/TwoPanePage.vue";
  import DefaultMessagesList from "@/components/Admin/DefaultMessages/DefaultMessagesList.vue";
  import DefaultMessageForm from "@/components/Admin/DefaultMessages/DefaultMessageForm.vue";
  import { useDefaultMessagesStore } from "@stores/survey/defaultMessages";

  const store = useDefaultMessagesStore();
  const { selectedMessage } = storeToRefs(store);
</script>

<template>
  <TwoPanePage>
    <template #left>
      <DefaultMessagesList />
    </template>
    <template #right>
      <DefaultMessageForm
        v-if="selectedMessage"
        :key="selectedMessage.language" />
      <div
        v-else
        class="flex items-center justify-center h-64 text-muted-foreground text-sm">
        Select a language to edit its messages
      </div>
    </template>
  </TwoPanePage>
</template>
